import { Pipe, PipeTransform } from '@angular/core';
import { JurisdictionType } from "@models/trusts/trusts-enums";
import { AustralianState } from "@models/address/australian-state.enum";

@Pipe({
  name: 'jurisdiction',
  standalone: true
})
export class JurisdictionPipe implements PipeTransform {
  transform(value: JurisdictionType | null): string {
    if(value !== null)
      return AustralianState[JurisdictionType[value]] as string;

    return '-';
  }
}
